  ;(function () {
    var kohConfig = (function () {
      var el = document.getElementById('koh-meal-one-30-config')
      if (!el || !el.textContent) return {}
      try {
        return JSON.parse(el.textContent)
      } catch (e) {
        return {}
      }
    })()
    var kohOrderNote = kohConfig.orderNote || ''
    var KOH_CHECKOUT_DISCOUNT_CODE = kohConfig.discountCode || 'FREE-SHIPPING-30'
    var pendingCheckoutBtn = null
    var selectedGiftHandle = null
    var giftCheckoutInProgress = false
    var kohBuyLastFlavor = null
    var giftProducts = (function () {
      var el = document.getElementById('koh-mean-one-gift-products')
      if (!el || !el.textContent) return []
      try {
        var parsed = JSON.parse(el.textContent)
        return Array.isArray(parsed)
          ? parsed.filter(function (p) {
              return p && p.handle
            })
          : []
      } catch (e) {
        return []
      }
    })()

    function giftNotePrefix() {
      var name = window.Shopify && window.Shopify.theme && window.Shopify.theme.name
      if (typeof name === 'string' && name.trim()) return name.trim() + ' --- [KOH_FREE_GIFT]:'
      return '[KOH_FREE_GIFT]:'
    }

    function buildCartNote(giftTitle) {
      var lines = (kohOrderNote || '')
        .split('\n')
        .map(function (line) {
          return line.trimEnd()
        })
        .filter(function (line) {
          return line && line.indexOf('[KOH_FREE_GIFT]:') === -1
        })
      if (giftTitle) lines.push(giftNotePrefix() + ' ' + giftTitle)
      return lines.join('\n')
    }

    function getCheckoutUrlWithDiscount(giftTitle) {
      var params = []
      var code = (KOH_CHECKOUT_DISCOUNT_CODE || '').trim()
      var note = buildCartNote(giftTitle || '')
      if (code) params.push('discount=' + encodeURIComponent(code))
      if (note) params.push('note=' + encodeURIComponent(note))
      return params.length ? '/checkout?' + params.join('&') : '/checkout'
    }

    function persistGiftSelection(product) {
      if (!product) return
      try {
        localStorage.setItem(
          'koh_selected_gift',
          JSON.stringify({
            handle: product.handle,
            title: product.title,
            image: product.featured_image,
            description: 'with subscription',
          })
        )
        localStorage.removeItem('koh_skip_gift')
        localStorage.setItem(
          'koh_available_gifts',
          JSON.stringify(
            giftProducts.slice(0, 2).map(function (p) {
              return { handle: p.handle, title: p.title, image: p.featured_image, description: 'with subscription' }
            })
          )
        )
        window.dispatchEvent(new CustomEvent('koh-gifts-updated'))
      } catch (e) {}
    }

    function getSelectedGiftProduct() {
      if (!selectedGiftHandle) return null
      for (var i = 0; i < giftProducts.length; i++) {
        if (giftProducts[i].handle === selectedGiftHandle) return giftProducts[i]
      }
      return giftProducts[0] || null
    }

    function renderGiftPopup() {
      var grid = document.getElementById('koh-gift-popup-grid')
      var confirmBtn = document.getElementById('koh-gift-popup-confirm')
      if (!grid) return
      grid.innerHTML = ''
      if (!giftProducts.length) return
      if (!selectedGiftHandle) selectedGiftHandle = giftProducts[0].handle

      giftProducts.slice(0, 2).forEach(function (product) {
        var card = document.createElement('button')
        card.type = 'button'
        card.className = 'koh-gift-popup-card' + (product.handle === selectedGiftHandle ? ' is-selected' : '')
        card.setAttribute('data-gift-handle', product.handle)
        var imgWrap = document.createElement('div')
        imgWrap.className = 'koh-gift-popup-card-img'
        if (product.featured_image) {
          var img = document.createElement('img')
          img.src = product.featured_image
          img.alt = product.title
          img.loading = 'lazy'
          imgWrap.appendChild(img)
        }
        var title = document.createElement('div')
        title.className = 'koh-gift-popup-card-title'
        title.textContent = product.title
        var check = document.createElement('span')
        check.className = 'koh-gift-popup-check'
        check.setAttribute('aria-hidden', 'true')
        check.textContent = '✓'
        card.appendChild(imgWrap)
        card.appendChild(title)
        card.appendChild(check)
        card.addEventListener('click', function () {
          selectedGiftHandle = product.handle
          persistGiftSelection(product)
          grid.querySelectorAll('.koh-gift-popup-card').forEach(function (c) {
            c.classList.toggle('is-selected', c.getAttribute('data-gift-handle') === selectedGiftHandle)
          })
          if (confirmBtn) confirmBtn.textContent = 'Add ' + product.title
        })
        grid.appendChild(card)
      })

      var selected = getSelectedGiftProduct()
      if (confirmBtn && selected) confirmBtn.textContent = 'Add ' + selected.title
    }

    function setGiftPopupLoading(loading) {
      giftCheckoutInProgress = loading
      var popup = document.getElementById('koh-gift-popup')
      var confirmBtn = document.getElementById('koh-gift-popup-confirm')
      var skipBtn = document.getElementById('koh-gift-popup-skip')
      var closeBtn = document.getElementById('koh-gift-popup-close')
      if (popup) popup.classList.toggle('is-loading', loading)
      if (confirmBtn) {
        confirmBtn.disabled = loading
        confirmBtn.textContent = loading
          ? 'Adding...'
          : getSelectedGiftProduct()
            ? 'Add ' + getSelectedGiftProduct().title
            : 'Add gift'
      }
      if (skipBtn) skipBtn.disabled = loading
      if (closeBtn) closeBtn.disabled = loading
    }

    function openGiftPopup(btn) {
      var popup = document.getElementById('koh-gift-popup')
      if (!popup || !giftProducts.length) {
        kohCheckoutViaApi(btn, true, '')
        return
      }
      pendingCheckoutBtn = btn
      giftCheckoutInProgress = false
      renderGiftPopup()
      setGiftPopupLoading(false)
      popup.classList.add('is-open')
      popup.setAttribute('aria-hidden', 'false')
      document.body.classList.add('koh-gift-popup-open')
    }

    function closeGiftPopup() {
      if (giftCheckoutInProgress) return
      var popup = document.getElementById('koh-gift-popup')
      if (!popup) return
      popup.classList.remove('is-open', 'is-loading')
      popup.setAttribute('aria-hidden', 'true')
      document.body.classList.remove('koh-gift-popup-open')
      setGiftPopupLoading(false)
    }

    function startGiftCheckout(giftTitle) {
      if (giftCheckoutInProgress) return
      setGiftPopupLoading(true)
      executeCheckout(true, giftTitle || '').catch(function (err) {
        console.error(err)
        alert(err && err.message ? err.message : 'Checkout could not start. Please try again.')
        setGiftPopupLoading(false)
      })
    }

    function onGiftConfirm() {
      if (giftCheckoutInProgress) return
      var selected = getSelectedGiftProduct()
      if (selected) persistGiftSelection(selected)
      startGiftCheckout(selected ? selected.title : '')
    }

    function onGiftSkip() {
      if (giftCheckoutInProgress) return
      try {
        localStorage.setItem('koh_skip_gift', '1')
        localStorage.removeItem('koh_selected_gift')
      } catch (e) {}
      startGiftCheckout('')
    }

    ;(function bindGiftPopup() {
      var closeBtn = document.getElementById('koh-gift-popup-close')
      var confirmBtn = document.getElementById('koh-gift-popup-confirm')
      var skipBtn = document.getElementById('koh-gift-popup-skip')
      var popup = document.getElementById('koh-gift-popup')
      if (closeBtn) closeBtn.addEventListener('click', onGiftSkip)
      if (confirmBtn) confirmBtn.addEventListener('click', onGiftConfirm)
      if (skipBtn) skipBtn.addEventListener('click', onGiftSkip)
      if (popup) {
        popup.addEventListener('click', function (e) {
          if (e.target === popup && !giftCheckoutInProgress) onGiftSkip()
        })
      }
    })()

    function isGiftPopupEligible() {
      return state.plan === 'subscribe' && giftProducts.length > 0 && isBoxQtyReadyForCheckout()
    }

    var KOH_MAX_QTY = 20

    /* Default selling plan = 30 days (matches active tab + checkout URLs in theme settings) */
    var state = {
      flavor: 'applecinnamon',
      plan: 'subscribe',
      sellingPlanId: '26631930074',
      buySliderIndex: 0,
      selectedBoxQty: 2,
      selectedOtpBoxQty: 1,
      flavorAddOrder: [],
      flavorQty: {
        applecinnamon: 0,
        maplecaramel: 0,
        peanutbutterbanana: 0,
        strawberrywalnutcream: 0,
        chocolate: 0,
        vanilla: 0,
        blueberrybanana: 0,
        variety: 0,
      },
    }

    /* Variant IDs per flavor (same as checkout URL line items in theme settings) */
    var kohVariantByFlavor = {
      applecinnamon: 45909544960218,
      maplecaramel: 45909544861914,
      peanutbutterbanana: 45909544829146,
      strawberrywalnutcream: 45909545025754,
      chocolate: 45909544992986,
      vanilla: 45909544927450,
      blueberrybanana: 45909544894682,
      variety: 46330447724762,
    }
    /** Per-box OTP and subscribe (30% off first order) — all totals derive from these so 5+ boxes match 1–4 */
    var KOH_OTP_PER_BOX = 38.99
    var KOH_SUB_PER_BOX = KOH_OTP_PER_BOX * 0.7
    var KOH_SUB_PER_MEAL = KOH_SUB_PER_BOX / 7

    var kohTierData = {
      '1box': {
        title: '1 Box',
        meals: '/ 7 meals',
        badge: '',
        badgeBg: '',
        subDetail: '(30% off first order, $' + KOH_SUB_PER_MEAL.toFixed(2) + '/meal)',
        otpDetail: 'One-time purchase',
      },
      '2box': {
        title: '2 Boxes',
        meals: '/ 14 meals',
        badge: 'MOST POPULAR',
        badgeBg: '#fcc42b',
        subDetail: '(30% off first order, $' + KOH_SUB_PER_MEAL.toFixed(2) + '/meal)',
        otpDetail: 'One-time purchase',
      },
      '3box': {
        title: '3 Boxes',
        meals: '/ 21 meals',
        badge: 'BEST VALUE',
        badgeBg: '#27ae60',
        subDetail: '(30% off first order, $' + KOH_SUB_PER_MEAL.toFixed(2) + '/meal)',
        otpDetail: 'One-time purchase',
      },
      '4box': {
        title: '4 Boxes',
        meals: '/ 28 meals',
        badge: 'BEST DEAL',
        badgeBg: '#00E8E9',
        subDetail: '(30% off first order, $' + KOH_SUB_PER_MEAL.toFixed(2) + '/meal)',
        otpDetail: 'One-time purchase',
      },
    }

    /** plan-id on the "30 days" button — must match HTML */
    var KOH_PLAN_ID_30_DAYS_TAB = '26631930074'
    /** Cart API selling_plan for 1 box + 30 days only (exception vs tab id) */
    var KOH_PLAN_ID_1BOX_30_DAYS = 26631930074

    function getTotalBoxes() {
      return Object.keys(state.flavorQty).reduce(function (sum, key) {
        return sum + (parseInt(state.flavorQty[key], 10) || 0)
      }, 0)
    }

    function getMealCount() {
      var boxes = getTotalBoxes()
      if (boxes < 1) boxes = getPricingDisplayQty()
      return boxes * 7
    }

    function getSelectedBoxCount() {
      return state.plan === 'subscribe' ? state.selectedBoxQty : state.selectedOtpBoxQty
    }

    function isOtpUnrestrictedQty() {
      return state.plan === 'onetime'
    }

    function getBoxMinQty() {
      if (isOtpUnrestrictedQty()) return 1
      return Math.max(0, Number(getSelectedBoxCount()) || (state.plan === 'subscribe' ? 2 : 1))
    }

    function isFlexibleBoxQty() {
      if (isOtpUnrestrictedQty()) return true
      return getSelectedBoxCount() >= 4
    }

    function getBoxMaxQty() {
      if (isOtpUnrestrictedQty()) return KOH_MAX_QTY
      if (isFlexibleBoxQty()) return KOH_MAX_QTY
      return getBoxMinQty()
    }

    function isBoxQtyReadyForCheckout() {
      var total = getTotalBoxes()
      var min = getBoxMinQty()
      if (isFlexibleBoxQty()) return total >= min && total > 0
      return total === min && total > 0
    }

    function getPricingDisplayQty() {
      var total = getTotalBoxes()
      if (total > 0) return Math.max(total, getSelectedBoxCount())
      return Math.max(getBoxMinQty(), getSelectedBoxCount())
    }

    function syncFlavorAddOrder(flavorKey, delta) {
      if (delta > 0) {
        for (var i = 0; i < delta; i++) state.flavorAddOrder.push(flavorKey)
        return
      }
      if (delta < 0) {
        var toRemove = -delta
        for (var j = state.flavorAddOrder.length - 1; j >= 0 && toRemove > 0; j--) {
          if (state.flavorAddOrder[j] === flavorKey) {
            state.flavorAddOrder.splice(j, 1)
            toRemove--
          }
        }
      }
    }

    function trimQtyToBoxCount(targetCount) {
      var total = getTotalBoxes()
      var removeCount = total - targetCount
      if (removeCount <= 0) return

      for (var i = 0; i < removeCount; i++) {
        if (!state.flavorAddOrder.length) break
        var lastKey = state.flavorAddOrder.pop()
        var current = parseInt(state.flavorQty[lastKey], 10) || 0
        if (current <= 1) state.flavorQty[lastKey] = 0
        else state.flavorQty[lastKey] = current - 1
      }
    }

    function enforceBoxQtyLimit() {
      var max = getBoxMaxQty()
      if (getTotalBoxes() > max) trimQtyToBoxCount(max)
    }

    function refreshAllFlavorRows() {
      var atBoxMax = getTotalBoxes() >= getBoxMaxQty()
      document.querySelectorAll('.koh-flavor-row').forEach(function (row) {
        var flavorBtn = row.querySelector('.koh-pill[data-flavor]')
        if (!flavorBtn) return
        var flavorKey = flavorBtn.getAttribute('data-flavor')
        var qty = parseInt(state.flavorQty[flavorKey], 10) || 0
        var stepperBtns = row.querySelectorAll('.koh-flavor-stepper-btn')
        var minusBtn = stepperBtns[0]
        var plusBtn = stepperBtns[1]
        var countEl = row.querySelector('[data-flavor-count]')
        if (countEl) countEl.textContent = String(qty)
        if (minusBtn) minusBtn.disabled = qty === 0
        if (plusBtn) plusBtn.disabled = atBoxMax
        flavorBtn.classList.toggle('active', flavorKey === state.flavor || qty > 0)
      })
    }

    function setFlavorQty(flavorKey, qty) {
      if (!flavorKey || state.flavorQty[flavorKey] == null) return
      var prevQty = parseInt(state.flavorQty[flavorKey], 10) || 0
      var newQty = Math.max(0, qty)
      var delta = newQty - prevQty
      var currentTotal = getTotalBoxes()

      if (delta > 0) {
        var maxAllowed = getBoxMaxQty()
        if (currentTotal >= maxAllowed) return
        if (currentTotal + delta > maxAllowed) {
          newQty = prevQty + (maxAllowed - currentTotal)
          delta = newQty - prevQty
          if (delta <= 0) return
        }
      }

      state.flavorQty[flavorKey] = newQty
      syncFlavorAddOrder(flavorKey, delta)
      enforceBoxQtyLimit()

      if (newQty > 0) {
        state.flavor = flavorKey
        state.buySliderIndex = 0
      }

      refreshAllFlavorRows()
      updateUI()
    }

    function syncBoxCardSelection(root) {
      if (!root) return
      var selected = getSelectedBoxCount()
      var plan = state.plan === 'subscribe' ? 'subscribe' : 'onetime'
      root.querySelectorAll('[data-koh-box-cards][data-box-plan="' + plan + '"] [data-koh-box-card]').forEach(function (card) {
        var count = parseInt(card.getAttribute('data-box-count'), 10)
        var isSelected = count === selected
        card.classList.toggle('is-selected', isSelected)
        card.setAttribute('aria-pressed', isSelected ? 'true' : 'false')
      })
    }

    function formatBoxSaveLabel(count) {
      var saving = (KOH_OTP_PER_BOX - KOH_SUB_PER_BOX) * count
      if (saving <= 0) return ''
      return 'Save ' + formatMoney(saving)
    }

    function updateBoxCardSavings(root) {
      if (!root) return
      root.querySelectorAll('[data-koh-box-cards][data-box-plan="subscribe"] [data-koh-box-card]').forEach(function (card) {
        var count = parseInt(card.getAttribute('data-box-count'), 10)
        var saveEl = card.querySelector('[data-koh-box-card-save]')
        if (!saveEl || !count) return
        var label = formatBoxSaveLabel(count)
        saveEl.textContent = label
        saveEl.hidden = !label
      })
    }

    function getDynamicPrices() {
      var displayQty = getPricingDisplayQty()
      return {
        subPrice: formatMoney(KOH_SUB_PER_BOX * displayQty),
        onetimePrice: formatMoney(KOH_OTP_PER_BOX * displayQty),
        comparePrice: formatMoney(KOH_OTP_PER_BOX * displayQty),
      }
    }

    function formatPleaseAddBoxes(remaining) {
      return 'PLEASE ADD ' + remaining + ' BOX' + (remaining === 1 ? '' : 'ES')
    }

    function formatPleaseAddBoxesWithPrice(remaining) {
      var base = formatPleaseAddBoxes(remaining)
      if (getTotalBoxes() <= 0) return base
      var p = getDynamicPrices()
      var price = state.plan === 'subscribe' ? p.subPrice : p.onetimePrice
      if (price && price !== '$0.00') return base + ' - ' + price
      return base
    }

    function formatAtcCounter() {
      var total = getTotalBoxes()
      var box = getSelectedBoxCount()
      if (isOtpUnrestrictedQty()) {
        var min = getBoxMinQty()
        var otpDenominator = total > 0 ? total : min
        return '(' + total + '/' + otpDenominator + ')'
      }
      var denominator = isFlexibleBoxQty() && total > box ? total : box
      return '(' + total + '/' + denominator + ')'
    }

    function getAtcPriceLabel() {
      var p = getDynamicPrices()
      var price = state.plan === 'subscribe' ? p.subPrice : p.onetimePrice
      return price && price !== '$0.00' ? 'ADD TO CART - ' + price : 'ADD TO CART'
    }

    function applyAtcButtonContent(labelEl, counterEl, labelText, counter, showCounter) {
      if (labelEl) labelEl.textContent = labelText
      if (counterEl) {
        counterEl.textContent = showCounter ? counter : ''
        counterEl.hidden = !showCounter
      }
    }

    function getAtcButtonState() {
      var total = getTotalBoxes()
      var minQty = getBoxMinQty()
      var counter = formatAtcCounter()
      var priceLabel = getAtcPriceLabel()
      var enabled = isBoxQtyReadyForCheckout()
      var remaining = Math.max(0, minQty - total)
      var labelText = 'ADD TO CART'
      var desktopLabelText = 'ADD TO CART'

      if (enabled) {
        labelText = priceLabel
        desktopLabelText = 'ADD TO CART'
      } else if (remaining > 0) {
        labelText = formatPleaseAddBoxes(remaining)
        desktopLabelText = formatPleaseAddBoxes(remaining)
      } else {
        labelText = priceLabel
        desktopLabelText = 'ADD TO CART'
      }

      return {
        enabled: enabled,
        labelText: labelText,
        desktopLabelText: desktopLabelText,
        counter: counter,
        showCounter: true,
      }
    }

    function updateCheckoutButton(root) {
      var btn = root ? root.querySelector('#koh-checkout-btn') : null
      if (!btn || btn.getAttribute('aria-busy') === 'true') return

      var atcState = getAtcButtonState()
      var labelEl = btn.querySelector('[data-koh-atc-label]')
      var counterEl = btn.querySelector('[data-koh-atc-counter]')
      var remaining = Math.max(0, getBoxMinQty() - getTotalBoxes())

      btn.disabled = !atcState.enabled
      btn.classList.toggle('is-enabled', atcState.enabled)
      btn.setAttribute('aria-disabled', atcState.enabled ? 'false' : 'true')

      applyAtcButtonContent(
        labelEl,
        counterEl,
        !atcState.enabled && remaining > 0
          ? formatPleaseAddBoxes(remaining)
          : atcState.desktopLabelText,
        atcState.counter,
        atcState.showCounter
      )

      var purchaseSection = root ? root.querySelector('#koh-purchase-section') : null
      if (purchaseSection) purchaseSection.classList.toggle('is-disabled', !atcState.enabled)
    }

    function getCurrentTierKey(boxesCount) {
      var total = boxesCount != null ? boxesCount : getTotalBoxes()
      if (total <= 1) return '1box'
      if (total === 2) return '2box'
      if (total === 3) return '3box'
      return '4box'
    }

    function resetFlavorQty() {
      Object.keys(state.flavorQty).forEach(function (key) {
        state.flavorQty[key] = 0
      })
    }

    function getActiveFlavorKey() {
      if (state.flavor && state.flavorQty[state.flavor] != null) return state.flavor
      var activePill = document.querySelector('.koh-pill.active[data-flavor]')
      if (activePill) return activePill.getAttribute('data-flavor')
      return state.flavor || 'applecinnamon'
    }


    function formatMoney(amount) {
      return '$' + amount.toFixed(2)
    }

    function getTierDataForCount(boxCount) {
      if (boxCount <= 0) {
        return {
          title: '0 Boxes',
          meals: '/ 0 meals',
          badge: '',
          badgeBg: '',
          subPrice: '$0.00',
          otpPrice: '$0.00',
          subDetail: '(30% off first order, $' + KOH_SUB_PER_MEAL.toFixed(2) + '/meal)',
          otpDetail: 'One-time purchase',
        }
      }
      var subTotal = KOH_SUB_PER_BOX * boxCount
      var otpTotal = KOH_OTP_PER_BOX * boxCount
      var key = getCurrentTierKey(boxCount)
      var base = kohTierData[key]
      if (boxCount >= 1 && boxCount <= 4 && base) {
        return {
          title: base.title,
          meals: base.meals,
          badge: base.badge,
          badgeBg: base.badgeBg,
          subPrice: formatMoney(subTotal),
          otpPrice: formatMoney(otpTotal),
          subDetail: base.subDetail,
          otpDetail: base.otpDetail,
        }
      }
      return {
        title: boxCount + (boxCount === 1 ? ' Box' : ' Boxes'),
        meals: '/ ' + boxCount * 7 + ' meals',
        badge: '',
        badgeBg: '',
        subPrice: formatMoney(subTotal),
        otpPrice: formatMoney(otpTotal),
        subDetail: '(30% off first order, $' + KOH_SUB_PER_MEAL.toFixed(2) + '/meal)',
        otpDetail: 'One-time purchase',
      }
    }

    function updateFlavorCounts() {
      document.querySelectorAll('[data-flavor-count]').forEach(function (el) {
        var key = el.getAttribute('data-flavor-count')
        var qty = parseInt(state.flavorQty[key], 10) || 0
        el.textContent = String(qty)
      })
    }

    function getCheckoutItems(includeSellingPlan) {
      var sellingPlan = parseInt(state.sellingPlanId, 10)
      if (getTotalBoxes() === 1 && String(state.sellingPlanId) === KOH_PLAN_ID_30_DAYS_TAB) {
        sellingPlan = KOH_PLAN_ID_1BOX_30_DAYS
      }
      var items = []
      Object.keys(state.flavorQty).forEach(function (flavorKey) {
        var qty = parseInt(state.flavorQty[flavorKey], 10) || 0
        if (qty < 1) return
        var variantId = kohVariantByFlavor[flavorKey]
        if (variantId == null) return
        var lineItem = { id: variantId, quantity: qty }
        if (includeSellingPlan) lineItem.selling_plan = sellingPlan
        items.push(lineItem)
      })
      return items
    }

    function executeCheckout(includeSellingPlan, giftTitle) {
      var items = getCheckoutItems(includeSellingPlan)
      if (!items.length) {
        console.error('KOH checkout: no valid items selected', state)
        return Promise.reject(new Error('Please select items before checkout.'))
      }
      return (async function () {
        var addRes = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        })
        var addData = await addRes.json().catch(function () {
          return {}
        })
        if (!addRes.ok) {
          throw new Error((addData.description || addData.message || addData.error || 'Cart add failed') + '')
        }
        window.location.href = getCheckoutUrlWithDiscount(giftTitle)
      })()
    }

    function kohCheckoutViaApi(btn, includeSellingPlan, giftTitle) {
      if (!btn || !isBoxQtyReadyForCheckout()) return
      var originalHTML = btn.innerHTML
      btn.disabled = true
      btn.setAttribute('aria-busy', 'true')
      btn.innerHTML = '<span class="pfp__atc-spinner"></span>'
      executeCheckout(includeSellingPlan, giftTitle)
        .catch(function (err) {
          console.error(err)
          alert(err && err.message ? err.message : 'Checkout could not start. Please try again.')
        })
        .finally(function () {
          btn.removeAttribute('aria-busy')
          btn.innerHTML = originalHTML
          updateCheckoutButton(document.body)
        })
    }

    var kohBuyFlavorImages = (function () {
      var el = document.getElementById('koh-buy-flavor-images')
      if (!el || !el.textContent) return {}
      try {
        return JSON.parse(el.textContent)
      } catch (e) {
        return {}
      }
    })()

    var kohBuySliderIndex = 0
    var kohBuySliderTotal = 0
    var kohBuySliderSwiped = false
    var kohBuySliderBound = false
    var kohBuyLightbox = null

    var elKohSliderWrap = null
    var elKohSliderTrack = null
    var elKohSliderPrev = null
    var elKohSliderNext = null
    var elKohThumbs = null
    var elKohDots = null
    var elKohSliderZoom = null
    var elKohSlider = null

    function getKohBuyFlavorImages(flavorKey) {
      var images = kohBuyFlavorImages[flavorKey]
      if (Array.isArray(images) && images.length) return images.filter(Boolean)
      return []
    }

    function getKohPfpThumbSrc(src) {
      if (!src) return src
      if (src.indexOf('width=') !== -1) return src.replace(/width=\d+/i, 'width=200')
      return src
    }

    function buildKohPfpDotButton(index, isActive) {
      return (
        '<button type="button" class="pfp__dot' +
        (isActive ? ' is-active' : '') +
        '" aria-label="Go to image ' +
        (index + 1) +
        '" data-dot-index="' +
        index +
        '"></button>'
      )
    }

    function buildKohPfpThumbButton(src, index, isActive) {
      return (
        '<button type="button" class="pfp__thumb' +
        (isActive ? ' is-active' : '') +
        '" aria-label="Go to image ' +
        (index + 1) +
        '" data-thumb-index="' +
        index +
        '">' +
        '<img src="' +
        getKohPfpThumbSrc(src).replace(/"/g, '&quot;') +
        '" alt="" width="200" height="200" loading="lazy">' +
        '</button>'
      )
    }

    function normalizeKohBuySlideIndex(idx) {
      if (!kohBuySliderTotal || kohBuySliderTotal <= 1) return 0
      return ((idx % kohBuySliderTotal) + kohBuySliderTotal) % kohBuySliderTotal
    }

    function goToKohBuySlide(idx) {
      if (!kohBuySliderTotal || !elKohSliderTrack) return
      kohBuySliderIndex = normalizeKohBuySlideIndex(idx)
      state.buySliderIndex = kohBuySliderIndex

      var slides = elKohSliderTrack.querySelectorAll('.pfp__slide')
      slides.forEach(function (el, i) {
        el.style.transform = 'translateX(' + (i - kohBuySliderIndex) * 100 + '%)'
      })

      if (elKohThumbs) {
        var thumbs = elKohThumbs.querySelectorAll('.pfp__thumb')
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === kohBuySliderIndex)
        })
        var activeThumb = thumbs[kohBuySliderIndex]
        if (activeThumb && typeof activeThumb.scrollIntoView === 'function') {
          activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
        }
      }

      if (elKohDots) {
        var dots = elKohDots.querySelectorAll('.pfp__dot')
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === kohBuySliderIndex)
        })
      }
    }

    function rebuildKohBuyFlavorSlider(flavorKey) {
      if (!elKohSliderTrack) return
      var images = getKohBuyFlavorImages(flavorKey)
      if (!images.length) return

      elKohSliderTrack.innerHTML = images
        .map(function (src, i) {
          return (
            '<div class="pfp__slide" style="transform: translateX(' +
            i * 100 +
            '%)">' +
            '<img src="' +
            src.replace(/"/g, '&quot;') +
            '" alt="Meal One product ' +
            flavorKey.replace(/"/g, '&quot;') +
            '" width="800" height="800" loading="' +
            (i === 0 ? 'eager' : 'lazy') +
            '">' +
            '</div>'
          )
        })
        .join('')

      if (elKohThumbs) {
        if (images.length > 1) {
          elKohThumbs.innerHTML = images
            .map(function (src, i) {
              return buildKohPfpThumbButton(src, i, i === 0)
            })
            .join('')
          elKohThumbs.hidden = false
        } else {
          elKohThumbs.innerHTML = ''
          elKohThumbs.hidden = true
        }
      }

      if (elKohDots) {
        if (images.length > 1) {
          elKohDots.innerHTML = images
            .map(function (_src, i) {
              return buildKohPfpDotButton(i, i === 0)
            })
            .join('')
          elKohDots.hidden = false
        } else {
          elKohDots.innerHTML = ''
          elKohDots.hidden = true
        }
      }

      if (elKohSliderZoom) elKohSliderZoom.hidden = images.length === 0
      if (elKohSliderPrev) elKohSliderPrev.hidden = images.length <= 1
      if (elKohSliderNext) elKohSliderNext.hidden = images.length <= 1

      kohBuySliderTotal = images.length
      var startIdx = Math.min(state.buySliderIndex || 0, Math.max(0, images.length - 1))
      state.buySliderIndex = startIdx
      goToKohBuySlide(startIdx)
    }

    function getKohBuyLightboxItems() {
      if (!elKohSliderTrack) return []
      return Array.prototype.slice
        .call(elKohSliderTrack.querySelectorAll('.pfp__slide img'))
        .map(function (img) {
          var src = img.currentSrc || img.src
          return {
            src: window.ProductGalleryLightbox ? window.ProductGalleryLightbox.getHiResSrc(src) : src,
            alt: img.alt || 'Product image',
          }
        })
        .filter(function (item) {
          return item.src
        })
    }

    function bindKohBuySliderControls() {
      if (kohBuySliderBound) return
      kohBuySliderBound = true

      elKohSliderPrev &&
        elKohSliderPrev.addEventListener('click', function () {
          goToKohBuySlide(kohBuySliderIndex - 1)
        })
      elKohSliderNext &&
        elKohSliderNext.addEventListener('click', function () {
          goToKohBuySlide(kohBuySliderIndex + 1)
        })

      if (elKohThumbs) {
        elKohThumbs.addEventListener('click', function (e) {
          var thumb = e.target.closest('.pfp__thumb')
          if (!thumb || thumb.dataset.thumbIndex == null) return
          goToKohBuySlide(parseInt(thumb.dataset.thumbIndex, 10))
        })
      }

      if (elKohDots) {
        elKohDots.addEventListener('click', function (e) {
          var dot = e.target.closest('.pfp__dot')
          if (!dot || dot.dataset.dotIndex == null) return
          goToKohBuySlide(parseInt(dot.dataset.dotIndex, 10))
        })
      }

      if (!elKohSlider) return

      var THRESHOLD = 40
      var startX = 0
      var startY = 0
      var active = false

      elKohSlider.addEventListener(
        'touchstart',
        function (e) {
          startX = e.touches[0].clientX
          startY = e.touches[0].clientY
          active = true
        },
        { passive: true }
      )

      elKohSlider.addEventListener(
        'touchmove',
        function (e) {
          if (!active) return
          var dx = e.touches[0].clientX - startX
          var dy = e.touches[0].clientY - startY
          if (Math.abs(dx) > Math.abs(dy)) e.preventDefault()
        },
        { passive: false }
      )

      elKohSlider.addEventListener(
        'touchend',
        function (e) {
          if (!active) return
          active = false
          var dx = e.changedTouches[0].clientX - startX
          if (Math.abs(dx) >= THRESHOLD) {
            kohBuySliderSwiped = true
            goToKohBuySlide(kohBuySliderIndex + (dx < 0 ? 1 : -1))
          }
        },
        { passive: true }
      )

      elKohSlider.addEventListener('touchcancel', function () {
        active = false
      })

      elKohSlider.addEventListener('mousedown', function (e) {
        if (e.target.closest('.pfp__slider-arrow') || e.target.closest('.pfp__slider-zoom')) return
        startX = e.clientX
        active = true
        elKohSlider.style.cursor = 'grabbing'
      })

      window.addEventListener('mouseup', function (e) {
        if (!active) return
        active = false
        elKohSlider.style.cursor = ''
        var dx = e.clientX - startX
        if (Math.abs(dx) >= THRESHOLD) {
          kohBuySliderSwiped = true
          goToKohBuySlide(kohBuySliderIndex + (dx < 0 ? 1 : -1))
        }
      })
    }

    function initKohBuyGalleryLightbox() {
      var lightboxRoot = document.getElementById('koh-buy-gallery-lightbox')
      if (!lightboxRoot || !window.ProductGalleryLightbox || lightboxRoot.dataset.kohPglBound === 'true') return
      lightboxRoot.dataset.kohPglBound = 'true'

      kohBuyLightbox = new window.ProductGalleryLightbox(lightboxRoot).configure({
        getItems: getKohBuyLightboxItems,
        getActiveIndex: function () {
          return kohBuySliderIndex
        },
        getSwipedFlag: function () {
          return kohBuySliderSwiped
        },
        clearSwipedFlag: function () {
          kohBuySliderSwiped = false
        },
        onSlideChange: function (idx) {
          goToKohBuySlide(idx)
        },
        slideSelector: '.pfp__slide',
        imgSelector: 'img',
      }).init()

      if (elKohSliderWrap) {
        elKohSliderWrap.addEventListener(
          'click',
          function () {},
          true
        )
        kohBuyLightbox.bindGallery(elKohSliderWrap)
      }

      if (elKohSliderZoom) {
        elKohSliderZoom.addEventListener('click', function (e) {
          e.preventDefault()
          e.stopPropagation()
          if (kohBuyLightbox) kohBuyLightbox.open(kohBuySliderIndex)
        })
      }
    }

    function initKohBuySlider() {
      elKohSliderWrap = document.getElementById('koh-buy-slider-wrap')
      if (!elKohSliderWrap) return

      elKohSlider = elKohSliderWrap.querySelector('[data-koh-img-slider]')
      elKohSliderTrack = elKohSliderWrap.querySelector('[data-koh-slider-track]')
      elKohSliderPrev = elKohSliderWrap.querySelector('[data-koh-slider-prev]')
      elKohSliderNext = elKohSliderWrap.querySelector('[data-koh-slider-next]')
      elKohThumbs = elKohSliderWrap.querySelector('[data-koh-thumbs]')
      elKohDots = elKohSliderWrap.querySelector('[data-koh-dots]')
      elKohSliderZoom = elKohSliderWrap.querySelector('[data-koh-slider-zoom]')

      bindKohBuySliderControls()
      initKohBuyGalleryLightbox()

      var initialImages = getKohBuyFlavorImages(state.flavor)
      kohBuySliderTotal = initialImages.length || elKohSliderTrack.querySelectorAll('.pfp__slide').length
      kohBuySliderIndex = Math.min(state.buySliderIndex || 0, Math.max(0, kohBuySliderTotal - 1))
      goToKohBuySlide(kohBuySliderIndex)
    }

    function updateBuyMediaSlider(root) {
      if (!elKohSliderTrack) {
        initKohBuySlider()
      }
      if (!elKohSliderTrack) return

      if (state.flavor !== kohBuyLastFlavor) {
        kohBuyLastFlavor = state.flavor
        rebuildKohBuyFlavorSlider(state.flavor)
        return
      }

      var maxIdx = Math.max(0, kohBuySliderTotal - 1)
      var currentIdx = Math.min(state.buySliderIndex || 0, maxIdx)
      state.buySliderIndex = currentIdx
      goToKohBuySlide(currentIdx)
    }


    function updateSubBoxDetails(root) {
      syncBoxCardSelection(root)
      updateBoxCardSavings(root)
    }

    function updatePurchaseCardsUI(root) {
      if (!root) return
      var displayQty = getPricingDisplayQty()
      var subTierData = getTierDataForCount(displayQty)
      var otpTierData = getTierDataForCount(displayQty)

      root.querySelectorAll('[data-koh-purchase-card]').forEach(function (card) {
        var plan = card.getAttribute('data-koh-purchase-card')
        var isActive = plan === state.plan
        card.classList.toggle('is-selected', isActive)
        var select = card.querySelector('[data-koh-purchase-select]')
        if (select) select.setAttribute('aria-pressed', isActive ? 'true' : 'false')
      })

      var subCompare = root.querySelector('[data-koh-sub-compare]')
      var subPrice = root.querySelector('[data-koh-sub-price]')
      var subPerUnit = root.querySelector('[data-koh-sub-per-unit]')
      var otpPrice = root.querySelector('[data-koh-onetime-price]')
      var otpPerUnit = root.querySelector('[data-koh-onetime-per-unit]')
      var subBadge = root.querySelector('[data-koh-sub-badge]')
      var delivery = root.querySelector('[data-koh-delivery-select]')

      if (subCompare) {
        subCompare.textContent = subTierData.otpPrice || ''
        subCompare.hidden = !subTierData.otpPrice
      }
      if (subPrice) subPrice.textContent = subTierData.subPrice
      if (subPerUnit) {
        subPerUnit.textContent =
          getMealCount() + ' meals • $' + KOH_SUB_PER_MEAL.toFixed(2) + '/meal'
      }
      if (otpPrice) otpPrice.textContent = otpTierData.otpPrice
      if (otpPerUnit) {
        otpPerUnit.textContent =
          getMealCount() + ' meals • $' + (KOH_OTP_PER_BOX / 7).toFixed(2) + '/meal'
      }
      if (subBadge) subBadge.hidden = getTotalBoxes() !== 2
      if (delivery && String(delivery.value) !== String(state.sellingPlanId)) {
        delivery.value = String(state.sellingPlanId)
      }
    }


    function updateUI() {
      var root = document.body

      updateFlavorCounts()
      refreshAllFlavorRows()
      updateSubBoxDetails(root)

      var flavorLabel = root ? root.querySelector('#koh-flavor-select-label') : null
      if (flavorLabel) {
        flavorLabel.textContent = state.plan === 'subscribe' ? '2. Select YOUR FLAVORS:' : 'Select at least 1 item:'
      }

      updateBuyMediaSlider(root)

      updatePurchaseCardsUI(root)

      /* Delivered-every tabs: subscription only */
      var planTabs = root ? root.querySelector('.koh-plan-changes-tabs') : null
      if (planTabs) {
        planTabs.style.display = state.plan === 'subscribe' ? 'none' : 'none'
      }
      if (root) {
        root.querySelectorAll('.plan_container_koh button[plan-id]').forEach(function (b) {
          b.classList.toggle('active', b.getAttribute('plan-id') === state.sellingPlanId)
        })
      }

      updateCheckoutButton(root)

      var selectedBoxes = getTotalBoxes()
      document.querySelectorAll('.for-subscription-only').forEach(function (el) {
        var show = state.plan === 'subscribe'
        el.style.display = show ? '' : 'none'
        el.hidden = !show
      })

      document.querySelectorAll('.for-onetime-only').forEach(function (el) {
        var show = state.plan === 'onetime'
        el.style.display = show ? '' : 'none'
        el.hidden = !show
      })

      /* Free Shipping pill: always visible with plan-specific message */
      document.querySelectorAll('.only-subscription-in-3boxes').forEach(function (el) {
        el.textContent = state.plan === 'subscribe' ? '🚚 Free Shipping on 3+ Boxes' : '🚚 Free Shipping at $99+'
        el.style.display = ''
        el.setAttribute('aria-hidden', 'false')
      })

      document.querySelectorAll('.only-subscription-over-2boxes').forEach(function (el) {
        var showGiftUnlocked = state.plan === 'subscribe' && selectedBoxes >= 2
        el.textContent = 'Free Gift'
        el.style.display = showGiftUnlocked ? '' : 'none'
        el.setAttribute('aria-hidden', showGiftUnlocked ? 'false' : 'true')
      })
    }

    window.kohSetFlavor = function (el) {
      state.flavor = el.getAttribute('data-flavor')
      state.buySliderIndex = 0

      document.querySelectorAll('.koh-pill').forEach(function (b) {
        b.classList.remove('active')
      })
      el.classList.add('active')

      document.querySelectorAll('.koh-tier').forEach(function (t) {
        t.classList.add('active')
      })

      updateUI()
    }

    window.kohAdjustFlavor = function (el, delta) {
      var row = el.closest('.koh-flavor-row')
      if (!row) return
      var flavorBtn = row.querySelector('.koh-pill[data-flavor]')
      if (!flavorBtn) return
      var flavorKey = flavorBtn.getAttribute('data-flavor')
      if (!flavorKey) return
      var currentQty = parseInt(state.flavorQty[flavorKey], 10) || 0
      if (delta === 1) {
        state.flavor = flavorKey
        state.buySliderIndex = 0
        setFlavorQty(flavorKey, currentQty + 1)
        return
      }
      if (delta === -1) {
        setFlavorQty(flavorKey, currentQty - 1)
      }
    }

    window.kohSetPlan = function (planOrEl) {
      if (planOrEl && planOrEl.getAttribute) {
        state.plan = planOrEl.getAttribute('data-plan') === 'onetime' ? 'onetime' : 'subscribe'
      } else {
        state.plan = planOrEl === 'onetime' ? 'onetime' : 'subscribe'
      }
      if (getTotalBoxes() > getBoxMaxQty()) {
        trimQtyToBoxCount(getBoxMaxQty())
      }
      refreshAllFlavorRows()
      updateUI()
    }
    ;(function bindSellingPlanTabs() {
      var wrap = document.body
      if (!wrap) return
      wrap.addEventListener('click', function (e) {
        var planBtn = e.target.closest('.plan_container_koh button[plan-id]')
        if (!planBtn) return
        var pid = planBtn.getAttribute('plan-id')
        if (!pid) return
        state.sellingPlanId = pid
        updateUI()
      })
    })()
    ;(function bindSubBoxCards() {
      var wrap = document.body
      if (!wrap) return
      wrap.addEventListener('click', function (e) {
        var card = e.target.closest('[data-koh-box-card]')
        if (!card) return
        var cardsWrap = card.closest('[data-koh-box-cards]')
        if (!cardsWrap) return
        var plan = cardsWrap.getAttribute('data-box-plan')
        if (plan !== state.plan) return
        var count = parseInt(card.getAttribute('data-box-count'), 10)
        if (!count || count === getSelectedBoxCount()) return
        if (plan === 'subscribe') state.selectedBoxQty = count
        else state.selectedOtpBoxQty = count
        if (getTotalBoxes() > getBoxMaxQty()) {
          trimQtyToBoxCount(getBoxMaxQty())
        }
        refreshAllFlavorRows()
        updateUI()
      })
    })()
    ;(function bindCheckoutButton() {
      var btn = document.getElementById('koh-checkout-btn')
      if (!btn || btn.dataset.kohCheckoutBound === 'true') return
      btn.dataset.kohCheckoutBound = 'true'
      btn.addEventListener('click', function (e) {
        e.preventDefault()
        if (!isBoxQtyReadyForCheckout()) return
        if (isGiftPopupEligible()) {
          openGiftPopup(btn)
          return
        }
        kohCheckoutViaApi(btn, state.plan === 'subscribe', '')
      })
    })()
    ;(function bindPurchaseCards() {
      var wrap = document.body
      if (!wrap) return
      wrap.addEventListener('click', function (e) {
        var select = e.target.closest('[data-koh-purchase-select]')
        if (!select) return
        var card = select.closest('[data-koh-purchase-card]')
        if (!card) return
        var plan = card.getAttribute('data-koh-purchase-card')
        if (plan === 'subscribe' || plan === 'onetime') kohSetPlan(plan)
      })
      var delivery = wrap.querySelector('[data-koh-delivery-select]')
      if (delivery) {
        delivery.addEventListener('change', function () {
          state.sellingPlanId = this.value
          updateUI()
        })
        delivery.addEventListener('click', function (e) {
          e.stopPropagation()
        })
      }
    })()
    ;(function kohIngredientsModal() {
      var wrap = document.body
      if (!wrap) return
      var modal = wrap.querySelector('#koh-ingredients-modal')
      var openBtn = wrap.querySelector('#koh-open-ingredients-modal')
      var backdrop = wrap.querySelector('.koh-ingredients-modal-backdrop')
      var closeBtn = wrap.querySelector('.close-ingredients-modal-btn')
      if (!modal || !openBtn) return

      var lastFocus = null

      function bindSlider(sliderRoot) {
        var track = sliderRoot.querySelector('.koh-ing-track')
        var prevBtn = sliderRoot.querySelector('.koh-ing-arrow-prev')
        var nextBtn = sliderRoot.querySelector('.koh-ing-arrow-next')
        var dotsWrap = sliderRoot.querySelector('.koh-ing-dots')
        var slides = sliderRoot.querySelectorAll('.koh-ing-slide')
        var n = slides.length
        if (!track || !prevBtn || !nextBtn || !dotsWrap || n < 1) return

        var idx = 0
        var dotButtons = []

        function setTransform() {
          track.style.transform = 'translateX(-' + idx * 100 + '%)'
        }

        function syncDots() {
          for (var d = 0; d < dotButtons.length; d++) {
            dotButtons[d].classList.toggle('is-active', d === idx)
            dotButtons[d].setAttribute('aria-current', d === idx ? 'true' : 'false')
          }
        }

        function go(nextIdx) {
          idx = ((nextIdx % n) + n) % n
          setTransform()
          syncDots()
        }

        dotsWrap.innerHTML = ''
        dotButtons = []
        for (var i = 0; i < n; i++) {
          ;(function (slideIndex) {
            var dot = document.createElement('button')
            dot.type = 'button'
            dot.className = 'koh-ing-dot' + (slideIndex === 0 ? ' is-active' : '')
            dot.setAttribute('aria-label', 'Image ' + (slideIndex + 1) + ' of ' + n)
            dot.setAttribute('aria-current', slideIndex === 0 ? 'true' : 'false')
            dot.addEventListener('click', function () {
              go(slideIndex)
            })
            dotsWrap.appendChild(dot)
            dotButtons.push(dot)
          })(i)
        }

        prevBtn.onclick = function () {
          go(idx - 1)
        }
        nextBtn.onclick = function () {
          go(idx + 1)
        }

        var viewport = sliderRoot.querySelector('.koh-ing-viewport')
        var wheelAccum = 0
        var wheelLastDir = 0
        function kohIngWheelSlide(e) {
          if (n <= 1 || !viewport) return
          var d = Math.abs(e.deltaX) >= Math.abs(e.deltaY) ? e.deltaX : e.deltaY
          if (Math.abs(d) < 1) return
          e.preventDefault()
          var dir = d > 0 ? 1 : -1
          if (wheelLastDir !== 0 && dir !== wheelLastDir) wheelAccum = 0
          wheelLastDir = dir
          wheelAccum += d
          var threshold = 45
          if (Math.abs(wheelAccum) >= threshold) {
            if (wheelAccum > 0) go(idx + 1)
            else go(idx - 1)
            wheelAccum = 0
            wheelLastDir = 0
          }
        }
        if (viewport) viewport.addEventListener('wheel', kohIngWheelSlide, { passive: false })

        /* Mobile: horizontal swipe / thumb drag to change slides (wheel handler does not run on touch) */
        var touchStartX = null
        var touchStartY = null
        function kohIngTouchReset() {
          touchStartX = null
          touchStartY = null
        }
        if (viewport && n > 1) {
          viewport.addEventListener(
            'touchstart',
            function (e) {
              if (e.touches.length !== 1) return
              touchStartX = e.touches[0].clientX
              touchStartY = e.touches[0].clientY
            },
            { passive: true }
          )
          viewport.addEventListener(
            'touchmove',
            function (e) {
              if (touchStartX == null || touchStartY == null || e.touches.length !== 1) return
              var dx = e.touches[0].clientX - touchStartX
              var dy = e.touches[0].clientY - touchStartY
              if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 12) {
                e.preventDefault()
              }
            },
            { passive: false }
          )
          viewport.addEventListener(
            'touchend',
            function (e) {
              if (touchStartX == null || !e.changedTouches[0]) {
                kohIngTouchReset()
                return
              }
              var dx = e.changedTouches[0].clientX - touchStartX
              var dy = e.changedTouches[0].clientY - touchStartY
              kohIngTouchReset()
              if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy)) return
              if (dx > 0) go(idx - 1)
              else go(idx + 1)
            },
            { passive: true }
          )
          viewport.addEventListener('touchcancel', kohIngTouchReset, { passive: true })
        }

        sliderRoot.kohIngReset = function () {
          idx = 0
          wheelAccum = 0
          wheelLastDir = 0
          kohIngTouchReset()
          setTransform()
          syncDots()
        }
      }

      wrap.querySelectorAll('[data-koh-ing-slider]').forEach(function (s) {
        bindSlider(s)
      })

      function setFlavorTab(flavor) {
        wrap.querySelectorAll('.koh-ingredients-modal-content-btn[data-ing-flavor]').forEach(function (btn) {
          var on = btn.getAttribute('data-ing-flavor') === flavor
          btn.classList.toggle('active', on)
          btn.setAttribute('aria-selected', on ? 'true' : 'false')
        })
        wrap.querySelectorAll('.koh-ing-panel[data-ing-panel]').forEach(function (p) {
          var on = p.getAttribute('data-ing-panel') === flavor
          p.classList.toggle('is-active', on)
          p.setAttribute('aria-hidden', on ? 'false' : 'true')
        })
        var activeSlider = wrap.querySelector('.koh-ing-panel.is-active [data-koh-ing-slider]')
        if (activeSlider && activeSlider.kohIngReset) activeSlider.kohIngReset()
      }

      function openModal() {
        lastFocus = document.activeElement
        modal.classList.add('is-open')
        modal.setAttribute('aria-hidden', 'false')
        document.body.classList.add('koh-ing-modal-open')
        setFlavorTab(typeof state !== 'undefined' && state.flavor ? state.flavor : 'applecinnamon')
        if (closeBtn) closeBtn.focus()
      }

      function closeModal() {
        modal.classList.remove('is-open')
        modal.setAttribute('aria-hidden', 'true')
        document.body.classList.remove('koh-ing-modal-open')
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus()
        lastFocus = null
      }

      openBtn.addEventListener('click', function () {
        openModal()
      })
      if (closeBtn)
        closeBtn.addEventListener('click', function () {
          closeModal()
        })
      if (backdrop)
        backdrop.addEventListener('click', function () {
          closeModal()
        })

      wrap.addEventListener('click', function (e) {
        var tab = e.target.closest('.koh-ingredients-modal-content-btn[data-ing-flavor]')
        if (!tab || !modal.contains(tab)) return
        var flavor = tab.getAttribute('data-ing-flavor')
        if (flavor) setFlavorTab(flavor)
      })

      document.addEventListener('keydown', function (e) {
        if (!modal.classList.contains('is-open')) return
        if (e.key === 'Escape') {
          e.preventDefault()
          closeModal()
          return
        }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          var activeSlider = wrap.querySelector('.koh-ing-panel.is-active [data-koh-ing-slider]')
          if (!activeSlider) return
          e.preventDefault()
          var prev = activeSlider.querySelector('.koh-ing-arrow-prev')
          var next = activeSlider.querySelector('.koh-ing-arrow-next')
          if (e.key === 'ArrowLeft' && prev) prev.click()
          if (e.key === 'ArrowRight' && next) next.click()
        }
      })
    })()

    window.kohToggleFaq = function (el) {
      var item = el.closest('.koh-faq-item')
      var wasOpen = item.classList.contains('open')
      document.querySelectorAll('.koh-faq-item').forEach(function (i) {
        i.classList.remove('open')
      })
      if (!wasOpen) item.classList.add('open')
    }

    /* #koh-buy anchors: on mobile only, scroll with offset so fixed header does not cover the section */
    var KOH_BUY_SCROLL_OFFSET = 90
    var kohBuyMobileMql = window.matchMedia('(max-width: 2100px)')

    function kohIsMobileBuyScrollViewport() {
      return kohBuyMobileMql.matches
    }

    function kohScrollToBuySection(smooth) {
      var target = document.getElementById('koh-buy')
      if (!target) return
      var y = target.getBoundingClientRect().top + window.scrollY - KOH_BUY_SCROLL_OFFSET
      window.scrollTo({ top: Math.max(0, y), behavior: smooth ? 'smooth' : 'auto' })
    }

    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href="#koh-buy"]')
      if (!a) return
      if (!kohIsMobileBuyScrollViewport()) return
      if (!document.getElementById('koh-buy')) return
      e.preventDefault()
      kohScrollToBuySection(true)
      if (history.pushState) {
        history.pushState(null, '', '#koh-buy')
      } else {
        window.location.hash = 'koh-buy'
      }
    })

    function kohApplyBuyHashOffset() {
      if (!kohIsMobileBuyScrollViewport()) return
      if (window.location.hash !== '#koh-buy') return
      if (!document.getElementById('koh-buy')) return
      requestAnimationFrame(function () {
        kohScrollToBuySection(false)
      })
    }

    /* Init */
    function init() {
      if (giftProducts.length && !selectedGiftHandle) {
        selectedGiftHandle = giftProducts[0].handle
        persistGiftSelection(giftProducts[0])
      }
      initKohBuySlider()
      updateUI()
      kohApplyBuyHashOffset()
    }

    window.addEventListener('hashchange', kohApplyBuyHashOffset)

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init)
    } else {
      init()
    }
  })()
